import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pos-report-print',
  templateUrl: './pos-report-print.component.html',
  styleUrls: ['./pos-report-print.component.scss']
})
export class PosReportPrintComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {
    setTimeout(() => {
      window.print();
      window.close();
    }, 1000);
  }
}
